import { combineReducers } from 'redux';
import { enableES5 } from 'immer';
import common from './common';
import product from './product';
import layer from './layer';
import review from './review';
import shoppingReview from './shoppingReview';
enableES5();
var rootReducer = combineReducers({
    common: common,
    product: product,
    layer: layer,
    review: review,
    shoppingReview: shoppingReview,
});
export default rootReducer;



//////////////////
// WEBPACK FOOTER
// ./src/detail/reducers/index.ts
// module id = 143
// module chunks = 0